export default __webpack_public_path__ + "static/media/Shetty.c763a271.png";